import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import AncShopCard from '../../../../ShopCard/AncShopCard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './MoreAnc.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
  className?: string;
}

const MAX_ITEMS = 1;

const MoreAnc: React.FC<Props> = ({ block, deviation: parentDeviation, className }) => {
  const deviations = block.deviations?.slice(0, MAX_ITEMS);

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  if (!deviations || deviations.length === 0) {
    return null;
  }

  return (
    <SidebarBlockWrapper className={className} deviation={parentDeviation} block={block}>
      <BiLoggerContextProvider value={{ sectionname: block.contentType }}>
        <DeviationDuperbrowseContext
          streamId={`sidebar-more-anc-${block.contentType}`}
          deviations={deviations}
          parent={{
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId,
          }}
        >
          <div ref={ref} className={s['root']}>
            {deviations.map(deviation => (
              <AncShopCard
                key={deviation.deviationId}
                deviation={deviation}
                width={measuredContainer.width}
                withAuthorDetails
              />
            ))}
          </div>
        </DeviationDuperbrowseContext>
      </BiLoggerContextProvider>
    </SidebarBlockWrapper>
  );
};
MoreAnc.displayName = 'MoreAnc';

export default MoreAnc;
